/* eslint-disable @typescript-eslint/no-explicit-any */
import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import TextField from '@mui/material/TextField';

export const StreamingContainer = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
});

export const StreamingItem = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
  padding: '12px 0',
  position: 'relative',
  '&:not(:first-of-type)': {
    borderTop: '1px solid #424242',
  },
});

export const StreamingItemHeader = styled('div')({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
});

export const StreamingItemTitle = styled('div')({
  fontWeight: 'bold',
  fontSize: '14px',
  color: '#fff',
});

export const StreamingItemActions = styled('div')({
  display: 'flex',
  gap: '4px',
});

export const StreamingItemDetails = styled('div')({
  fontSize: '12px',
  color: 'rgba(255, 255, 255, 0.7)',
  wordBreak: 'break-all',
  '& > div': {
    marginBottom: '4px',
  },
});

export const FormContainer = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  gap: '16px',
  width: '100%',
});

export const StyledTextField = styled(TextField)({
  '& .MuiInputBase-root': {
    color: '#fff',
    fontSize: '14px',
  },
  '& .MuiInputLabel-root': {
    color: 'rgba(255, 255, 255, 0.7)',
    fontSize: '14px',
  },
  '& .MuiOutlinedInput-root': {
    '& fieldset': {
      borderColor: 'rgba(255, 255, 255, 0.23)',
    },
    '&:hover fieldset': {
      borderColor: 'rgba(255, 255, 255, 0.5)',
    },
    '&.Mui-focused fieldset': {
      borderColor: '#44c0b9',
    },
  },
});

export const AddButton: any = styled(Button)({
  border: '1px solid rgb(68 192 185) !important',
  color: '#44c0b9',
  fontSize: '12px !important',
  textTransform: 'none',
  width: '100%',
  marginTop: '12px',
});
